type ParsedInt = {
  value: number | null;
  error: string | null;
};

function parsePositiveIntEnv(name: string): ParsedInt {
  const raw = process.env[name];
  if (!raw || raw.trim() === "") {
    return {
      value: null,
      error: `Missing env var ${name}. Define it in frontend/.env.local.`,
    };
  }

  const parsed = Number(raw);
  if (!Number.isInteger(parsed) || parsed < 1) {
    return {
      value: null,
      error: `Invalid ${name}="${raw}". Expected a positive integer.`,
    };
  }

  return { value: parsed, error: null };
}

const concurrentCalls = parsePositiveIntEnv("REACT_APP_CONCURRENT_CALLS");

export const runtimeConfig = {
  concurrentCalls: concurrentCalls.value,
  concurrentCallsError: concurrentCalls.error,
};

